const ParametersKeys = {
    ActiveDirectoryAuthEnabled: 'ActiveDirectoryAuthEnabled',
    ActiveDirectoryAllowedUserGroups: 'ActiveDirectoryAllowedUserGroups',
    ActiveDirectoryDomain: 'ActiveDirectoryDomain',
    ActiveDirectoryServerPath: 'ActiveDirectoryServerPath',
    AIRecognitionAPIURL: 'AIRecognitionAPIURL',
    AutorecognitionApiURL: 'AutorecognitionApiURL',
    AzureMicrosoftGraphApiURL: 'AzureMicrosoftGraphApiURL',
    AzureUseActiveDirectory: 'AzureUseActiveDirectory',
    ClientID: 'ClientID',
    ClientSecret: 'ClientSecret',
    CredentialID: 'CredentialID',
    QuoVadisV2ApiURL: 'QuoVadisV2ApiURL',
    DashboardCacheEnabled: 'DashboardCacheEnabled',
    DefaultContentTypesXMLPath: 'DefaultContentTypesXMLPath',
    DocumentAttachmentsRootFolderPath: 'DocumentAttachmentsRootFolderPath',
    DocumentsRootFolderPath: 'DocumentsRootFolderPath',
    ElasticSearchURL: 'ElasticSearchURL',
    JobsExecutionTime: 'JobsExecutionTime',
    JobsExecutionTimeDocumentLifeCycle: 'JobsExecutionTimeDocumentLifeCycle',
    JobsExecutionTimeDelegations: 'JobsExecutionTimeDelegations',
    JobsExecutionTimeDataManagement: 'JobsExecutionTimeDataManagement',
    JobsExecutionTimeAlert: 'JobsExecutionTimeAlert',
    JobsExecutionTimeConnectedServices: 'JobsExecutionTimeConnectedServices',
    JobsDocumentsWithMissingIndexesTakeDocs: 'JobsDocumentsWithMissingIndexesTakeDocs',
    JobsDocumentsWithMissingIndexesDuration: 'JobsDocumentsWithMissingIndexesDuration',
    LibreOfficePath: 'LibreOfficePath',
    LicenceKey: 'LicenceKey',
    LicenceServerURL: 'LicenceServerURL',
    LogIndexPath: 'LogIndexPath',
    LogQueuePath: 'LogQueuePath',
    OneDriveMicrosoftGraphApiURL: 'OneDriveMicrosoftGraphApiURL',
    OneDriveMicrosoftGraphClientID: 'OneDriveMicrosoftGraphClientID',
    OneDriveMicrosoftGraphClientSecret: 'OneDriveMicrosoftGraphClientSecret',
    OrgDataFolderPath: 'OrgDataFolderPath',
    PendingObjects: 'PendingObjects',
    SAMLEndpoint: 'SAMLEndpoint',
    SAMLCertificate: 'SAMLCertificate',
    SupportedFileFormats: 'SupportedFileFormats',
    TelerikReportTempFolderPath: 'TelerikReportTempFolderPath',
    TwoFactorAuthenticationApiURL: 'TwoFactorAuthenticationApiURL',
    UserID: 'UserID',
    WebApiURL: 'WebApiURL',
    WebsiteURL: 'WebsiteURL',
    MicrosoftEntraClientId: 'MicrosoftEntraClientId',
    MicrosoftEntraClientSecret: 'MicrosoftEntraClientSecret',
    MicrosoftEntraIDDefaultOrganizationId: 'MicrosoftEntraIDDefaultOrganizationId',
    OCRAPIURL: 'OCRAPIURL',
    RefreshTokenKey: 'RefreshToken',
    GoogleDriveClientId: 'GoogleDriveClientId',
    GoogleDriveClientSecret: 'GoogleDriveClientSecret',
    GoogleDriveApiUrl: 'GoogleDriveApiUrl',
    AIDefaultModel: 'AIDefaultModel'
};

Object.entries(ParametersKeys).forEach(([key, value]) => {
    ParametersKeys[value] = key;
});

export default ParametersKeys;